export default __webpack_public_path__ + "static/media/bd60f8e190c7463abe2db72da54a87c9.7c42aaba.png";